"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
require("../styles/Icon.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : IconActivation.js
* Description : Ce fichier contient la définition du composant IconActivation 
*               Ce composant affiche l'information sur l'activation ou non une option
* Date de création : 11 juillet 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* IconActivation : ce composant affiche un texte ou un autre en fonction d'un booléen 
*
* Type : composant 
*
* Parametres : 
*  - input -- Booléen pour déterminer l'affichage du texte correspondant
*             Si booléen = 1, texte = 'Activé', sinon texte = 'Non utilisé'
*/function IconActivation(_ref) {
  var input = _ref.input;
  // Render component
  if (input === 1) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-activation",
      children: "Activ\xE9"
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-activation",
      children: "Non utilis\xE9"
    });
  }
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
IconActivation.propTypes = {
  input: _propTypes["default"].number
};
var _default = exports["default"] = IconActivation;